import { dataHooks } from '../../../libs/dataHooks';

export const networkErrorModalDataHooks = dataHooks<{
  backdrop: {};
  title: {};
  description: {};
  ctaButton: {};
  closeButton: {};
}>('networkErrorModal');
